let _progressCursorDisplayCount = 0;

export default {
    show: () => {
        document.body.classList.add('mdb-loader-open');
        
        const backdrop = document.createElement('div');
        const spinner = document.createElement('div');
        
        backdrop.className = 'mdb-loader-component modal-backdrop show';
        spinner.className = 'mdb-loader-component download-loader';
        
        document.body.appendChild(backdrop);
        document.body.appendChild(spinner);
    },
    hide: () => {
        document.body.classList.remove('mdb-loader-open');
        
        document.querySelectorAll('.mdb-loader-component')
            .forEach(n => n.remove());
    },
    showProgressCursor: () => {
        _progressCursorDisplayCount++;
        document.body.classList.add('cursor-progress');
    },
    stopProgressCursor: () => {
        _progressCursorDisplayCount--;
        
        //Allow multiple calls to show to be made without undoing them all with a single stop call
        if(_progressCursorDisplayCount === 0){
            document.body.classList.remove('cursor-progress');   
        }
    }
};